<template>
  <div class="container">
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
      <i class="el-icon-s-fold" ></i>
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item >内容管理</el-breadcrumb-item>
        <el-breadcrumb-item >访问控制管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
      <div class="tabs-content">
          <div class="condition">
            <div style="">
              <el-tabs
              type="border-card"
              style="background-color: transparent;border: 1px solid #1A3F81;border-radius: 12px;"
              v-model="activeName"
              @tab-click="handleClick"
              >
                <el-tab-pane name="iplimit">
                  <span slot="label"><i class="el-icon-date"></i> IP访问控制</span>
                  <div class="list-used">
                      <div class="header-common">
                        <div class="header-common-left">
                          <div class="title">IP访问控制列表</div>
                        </div>
                        <header class="header-common-right">
                          <el-button
                            class="right-button-export"
                            @click="exportTable()"
                            type="text"
                            >
                            导出
                          </el-button>
                          <router-link class="right-button-base" :to="{path:'/manage/ip/ip-add'}" v-if="showActionAdd==true">
                            新增IP访问控制
                          </router-link>
                        </header>
                      </div>
                      <div >
                        <el-table
                          v-loading='loading'
                          style="width: 100%;"
                          border
                          default-expand-all
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          :max-height="tableHeight"
                          :data="tableData1"
                          >
                          <!-- :data="tableData1.filter(data => !search1 || data.typeCode.toLowerCase().includes(search1.toLowerCase()) || data.typeName.toLowerCase().includes(search1.toLowerCase()))" -->


                          <el-table-column
                            type="index"
                            label="序号">
                          </el-table-column>
                          <!-- <el-table-column
                            label="限制类别">
                            <template slot-scope="scope">
                              <span>IP访问控制</span>
                            </template>
                          </el-table-column> -->
                          <el-table-column
                            label="限制范围">
                            <template slot-scope="scope">
                              <div>
                                <span >{{scope.row.startIp}}</span>
                                <span> ~ </span>
                                <span>{{scope.row.endIp}}</span>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                              <el-button
                                v-if="showActionAdd==true"
                                @click.native.prevent="deleteIPLimitRow(scope.$index,scope.row)"
                                type="text"
                                size="small"
                                style="background-color: #20478D;"
                                class="action-button">
                                删除
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                  </div>
                </el-tab-pane>
                  <el-tab-pane style="background-color: transparent;" name="timelimit">
                    <span slot="label"><i class="el-icon-date"></i> 时间访问控制</span>
                    <div class="list-used">
                        <div class="header-common">
                          <div class="header-common-left">
                            <div class="title">时间访问控制列表</div>
                          </div>
                          <header class="header-common-right">
                            <router-link class="right-button-base" :to="{path:'/manage/ip/time-add'}" v-if="showActionAdd==true">
                              新增时间访问控制
                            </router-link>
                          </header>
                        </div>
                        <div >
                          <el-table
                            v-loading='loading'
                            style="width: 100%;"
                            row-key="id"
                            border
                            default-expand-all
                            border
                            :cell-style="tableCellStyle"
                            :header-cell-style="tableHeaderCellStyle"
                            :data="tableData2"
                            :max-height="tableHeight"
                            >
                            <!-- :data="tableData2.filter(data => !search2 || data.typeCode.toLowerCase().includes(search2.toLowerCase()) || data.typeName.toLowerCase().includes(search2.toLowerCase()))" -->

                            <el-table-column
                              label="限制类别">
                              <template slot-scope="scope">
                                <span>时间访问控制</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="限制内容">
                              <template slot-scope="scope">
                                <div>
                                  <span >{{scope.row.startTime}}</span>
                                  <span> ~ </span>
                                  <span>{{scope.row.endTime}}</span>
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="操作">
                              <template slot-scope="scope">
                                <el-button
                                  v-if="showActionAdd==true"
                                  @click.native.prevent="deleteTimeLimitRow(scope.$index,scope.row)"
                                  type="text"
                                  size="small"
                                  style="background-color: #20478D;"
                                  class="action-button">
                                  删除
                                </el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                    </div>
                  </el-tab-pane>
              </el-tabs>
            </div>
          </div>
      </div>
  </div>

</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {permissionCheckUtil} from '../../../utils/permission.js'

  export default {
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'color' : '#fff',
          'font-size': '15px',
          'font-weight': 'solid',
          'border-bottom':'0px solid #1A3F81',
          'border-right':'0px solid #1A3F81'
        },
        labelStyle:{
          'width': '108px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px solid #1A3F81',
        },
        tableHeight:0,
        tableData1:[],
        tableData2:[],
        loading:false,

        showActionAdd:false,
        activeName:'iplimit'
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;text-align:left;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:left;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      handleClick(tab, event){
        if (tab.name == 'iplimit') {
          this.getDataOfIP()
        } else if (tab.name == 'timelimit'){
          this.getDataOfTime()
        }
      },
      getDataOfIP(){
        this.loading=true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/system/ip/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.ipList){
                // 获取设备数据
                this.tableData1 = obj.data.ipList;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })

      },
      getDataOfTime(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/system/period/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.periods){
                // 获取设备数据
                this.tableData2 = obj.data.periods;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })

      },
      deleteIPLimitRow(index,row){
        this.$confirm('此操作将删除该访问控制，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteIPLimitRowAction(index,row.id);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消操作'
          })
        })
      },
      deleteIPLimitRowAction(index,id){

        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/system/ip/delete';
        const data = {
          "id":id
        };
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message('删除成功');
              this.tableData1.splice(index,1);
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      deleteTimeLimitRow(index,row){
        this.$confirm('此操作将删除该访问控制，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteTimeLimitRowAction(index,row.id);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消操作'
          })
        })
      },
      deleteTimeLimitRowAction(index,id){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/system/period/delete';
        const data = {
          "id":id
        };
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message('删除成功');
              this.tableData2.splice(index,1);
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      exportTable(){
        var tableHeader = [['序号','限制范围']];
        var dataList = [];
        this.tableData1.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.startIp+'～'+item.endIp
          ]);
        });
        
        if(dataList.length > 0){
          dataConversionUtil.dataToExcel('IP访问控制列表',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      judgePermissions(){
          let code1 = permissionCheckUtil.findName("system:accessControl");

          if(code1==true){
            this.showActionAdd = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-285 < 300 ? 300 : window.innerHeight-285;
        })
      }
    },
    created() {
      
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)
      
      this.sizeFun()
      this.getDataOfIP()
      this.judgePermissions();
    }
  }
</script>


<style lang="scss" scoped>
.container{
  margin-top: $header-height;

  .equipment-distribution{
    margin: 0px 0px 20px 7px;
    display: flex;
    flex-direction: row;

    .handle-distribution{
      width: 100%;
      min-width: 740px;
      height: 310px;
      // border: 2px #1A3F81 solid;
      border-radius: 18px;
      padding-right: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;

      .handle-one{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .line-left{
          margin-right: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }

        .line-middle{
          width: 162px;
          height: 162px;
          border-radius: 18px;
          // border: 2px solid rgba(0, 177, 183, 0.84);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .line-middle-rate{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);

            background: linear-gradient(0deg, #FF1800 0.1953125%, #D3CC15 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(180deg, #D3CC15 0%, #FF1800 100%);

              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-processing{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-finish{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }



          .line-middle-status{
            font-size: 22px;

            font-weight: bold;
            color: #fff;
            text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(180deg, #FFFFFF 0%, #47D6FF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin: 0;
          }
        }

        .line-right{
          margin-left: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }
      }
    }

    .distribution-list{
      margin-top: 0;
      margin: 0px 0px 0px 6px;
      padding-bottom: 10px;
    }
  }

  .tabs-content{
      .action-button{
        width: 89px;
        height: 31px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        // margin-right: 20px;
      }

    .table-content{

      .table-list{

      }
    }

  }

  // 公共头部样式

  .header-common{
    width: 100%;
    height: 45px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-right: 26px;

    .header-common-left{
      font-size: 20px;
      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
      .title{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
      }
    }
    .header-common-right{

      .right-button{
        width: 149px;
        height: 40px;
        background: #FAFAFA;
        border: 1px solid rgba(0,255,96,0.84);
        border-radius: 20px;
        background-color: #208D7F;
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }

      .right-button-export{
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }

      .right-button-base{
        width: 139px;
        height: 40px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        margin-right: 20px;
        display: inline-block;
        line-height: 40px;
        text-align: center;
        text-decoration: none;
      }
    }

  }

}

  .el-radio__input.is-checked .el-radio__label{
    color: #B26100 !important
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #B26100 !important;
    border-color: #B26100 !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/manage/ip/ip-list.vue